import React, { Component } from "react";
import { NavDropdown } from "react-bootstrap";


class SideBar extends Component {

    render() {  
        let isDev = process.env.REACT_APP_DEVELOPER === 'true'

        return (
            
          <NavDropdown title="Pages" id="collasible-nav-dropdown" style={{ zIndex: 999 }} >
            <NavDropdown.Item href="/entry-suggestion">Entry suggestions</NavDropdown.Item>
            <NavDropdown.Item href="/translations">Translations</NavDropdown.Item>
            <NavDropdown.Item href="/tickets">Tickets</NavDropdown.Item>
            <NavDropdown.Item href="/mobil-templates">Mobile Notification Templates</NavDropdown.Item>
            <NavDropdown.Item href="/mail-templates">E-Mail Notification Templates</NavDropdown.Item>
            <NavDropdown.Item href="/points-of-action-case">Points Of Action Case</NavDropdown.Item>
            <NavDropdown.Item href="/points-upload-option">Points Upload Option</NavDropdown.Item>
            <NavDropdown.Item href="/users">Users</NavDropdown.Item>
            <NavDropdown.Item href="/labels">Labels</NavDropdown.Item>
            <NavDropdown.Item href="/payments">Payments</NavDropdown.Item>
            <NavDropdown.Item href="/device-logs">Device logs</NavDropdown.Item>
            {<NavDropdown.Divider />}
            <NavDropdown.Item href="/statistics/advertisement-logs">Statistic: Advertisement Logs</NavDropdown.Item>
            {isDev && <NavDropdown.Divider />}
            {isDev && <NavDropdown.Item href="/change-password?token=">Change Password Test</NavDropdown.Item>}
          </NavDropdown>
        );
    }
}

export default SideBar;